import {css, view, tokens, createViewConfig} from '@sail/ui';
import {useTheme} from '../../ThemeProvider';
import type {Theme} from '../../theme';

type MessageType = 'user' | 'bot' | 'agent' | 'event';

const getBgColors = (theme: Theme): Record<MessageType, string> => ({
  user: theme.messageBubbleBackground,
  bot: 'transparent',
  agent: tokens.color.neutral[50].toString(),
  event: 'transparent',
});

const textColors: Record<MessageType, string> = {
  user: 'white',
  bot: 'text',
  agent: 'text',
  event: 'subdued',
};

export type ChatBubbleNextProps = {
  children?: React.ReactNode;
  messageType: MessageType;
};

export const ChatBubbleNextConfig = createViewConfig({
  props: {} as ChatBubbleNextProps,
  name: 'ChatBubble',
});

export const ChatBubbleNext = ChatBubbleNextConfig.createView(
  ({children, messageType, ...props}) => {
    const isPerson = ['user', 'agent'].includes(messageType);
    const theme = useTheme();
    const bgColors = getBgColors(theme);

    return (
      <view.div
        {...props}
        data-testid="chat-bubble"
        className="uh-conversations-chat-bubble"
        uses={[
          css({
            backgroundColor: bgColors[messageType],
            color: textColors[messageType],
            transition: 'border-radius .2s',
          }),

          isPerson &&
            css({
              paddingX: 'space.150',
              paddingY: 'small',
              borderRadius: 20,
            }),
        ]}
      >
        {children}
      </view.div>
    );
  },
);
